var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticStyle: { width: "fit-content" } }, [
    _c("canvas", {
      staticClass: "thumbnail",
      style: _vm.thumbnailStyle,
      attrs: { id: "thumbnail" + _vm.dir, alt: _vm.dir },
      on: { click: _vm.imageClick }
    }),
    _vm._v(" "),
    _vm.doc_id != undefined
      ? _c("p", { staticClass: "subtext" }, [_vm._v(_vm._s(_vm.doc_id))])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "modal", attrs: { id: "myModal" + _vm.dir } }, [
      _c("canvas", { class: _vm.isZoomed, attrs: { id: "img" + _vm.dir } }),
      _vm._v(" "),
      _vm.zoomed == false
        ? _c("div", { staticClass: "modal-button-group-light" }, [
            _c(
              "button",
              { staticClass: "modal-button", on: { click: _vm.close } },
              [
                _c("font-awesome-icon", {
                  staticClass: "modal-button-icon-light",
                  attrs: { size: "3x", icon: "times" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "button",
              { staticClass: "modal-button", on: { click: _vm.zoom } },
              [
                _c("font-awesome-icon", {
                  staticClass: "modal-button-icon-light",
                  attrs: { size: "3x", icon: "expand" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "button",
              { staticClass: "modal-button", on: { click: _vm.copy } },
              [
                _c("font-awesome-icon", {
                  staticClass: "modal-button-icon-light",
                  attrs: { size: "3x", icon: "save" }
                })
              ],
              1
            )
          ])
        : _c("div", { staticClass: "modal-button-group-dark" }, [
            _c(
              "button",
              { staticClass: "modal-button", on: { click: _vm.close } },
              [
                _c("font-awesome-icon", {
                  staticClass: "modal-button-icon-dark",
                  attrs: { size: "3x", icon: "times" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "button",
              { staticClass: "modal-button", on: { click: _vm.zoom } },
              [
                _c("font-awesome-icon", {
                  staticClass: "modal-button-icon-dark",
                  attrs: { size: "3x", icon: "compress" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "button",
              { staticClass: "modal-button", on: { click: _vm.copy } },
              [
                _c("font-awesome-icon", {
                  staticClass: "modal-button-icon-dark",
                  attrs: { size: "3x", icon: "save" }
                })
              ],
              1
            )
          ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8268bd8c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8268bd8c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/document.vue
// module id = 803
// module chunks = 0